'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import './UsableNet.scss';
const USABLE_NET_ICON_URL = 'https://a42cdn.usablenet.com/a42/petsmart/default/prod/cs-start';
const iconParams = new URLSearchParams({
  size: 'default',
  position: 'bottom-left',
  breakpoint: '600',
  'mobile-position': 'bottom-left'
});
export const UsableNetLegacy = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const url = `${USABLE_NET_ICON_URL}?${iconParams.toString()}`;
    t0 = <Script id="usntA42start" src={url} data-rapid="true" data-testid="velocity-usablenet-script" data-ot-ignore={true} strategy="afterInteractive" defer={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};